import { useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import { InlineSpinner } from "components/base/Spinner";
import TagsView from "components/base/TagsView";
import { FETCH_ODOO_CUSTOMER_TAGS } from "./graphql";

const OdooCustomerTagsView = ({ value, onChange }) => {
  const { loading, error, data } = useQuery(FETCH_ODOO_CUSTOMER_TAGS);

  if (loading) return <InlineSpinner />;
  if (error) return <Errors error={error} />;

  const options = JSON.parse(data?.odooCustomerTags || "[]").map((i) => ({
    value: i.id,
    label: i.display_name,
  }));

  return (
    <TagsView
      className="text-xs"
      value={value}
      onChange={onChange}
      options={options}
    />
  );
};

export default OdooCustomerTagsView;
